module.exports = __webpack_public_path__ + "static/img/ceshi.0eed3add.png";